import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@contexts";
import { getStoredTokens, isTokenExpired } from "@utils";

export function PublicOnlyRoute() {
  const { setIsUserAuthed, isRestoringSession } = useAuth();
  const navigate = useNavigate();
  // TODO: In the future, when we have sessions for different roles,
  // maybe we should check the user role before allow access or redirect him to the correct page
  const location = useLocation();
  const path = location.pathname;
  const noRedirectPaths = [
    "/app/farmacia",
    "/app/visualizacion-documento",
    "/app/verificacion",
  ];
  useEffect(() => {
    if (isRestoringSession) return;
    function checkAuth() {
      const tokens = getStoredTokens();
      console.log("tokens", tokens);
      if (tokens && !isTokenExpired(tokens.idToken)) {
        setIsUserAuthed(true);
        if (
          noRedirectPaths.some((noRedirectPath) =>
            path.startsWith(noRedirectPath),
          )
        )
          return;
        navigate("/app/solicitudes");
      }
    }
    checkAuth();
    // dont put navigate on the dependencies array, we want this only to happen on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRestoringSession]);

  return <Outlet />;
}
